const QUERY_KEYS = {
  SEARCH_BOOKING: 'searchBooking',
  GET_COUNTER: 'get_counter',
  GET_COUNTER_ACTIVITIES: 'get_counter_activities',
  GET_COUNTER_CHAT: 'get_counter_chat',
};

export default QUERY_KEYS;
